<template>
  <div class="map">
    <div id="map"></div>
    <div
      class="map__controls controls"
      v-touch:swipe.top="upControls"
      v-touch:swipe.down="downControls"
      ref="controls"
    >
      <div class="controls__swipe" />
      <div class="controls__search">
        <label class="controls__label" for="search">{{
          content[language].label
        }}</label>
        <input
          class="controls__input"
          type="text"
          id="search"
          :placeholder="content[language].placeholder"
        />
      </div>
      <ul class="controls__buttons">
        <li
          v-for="(speed, i) in speeds"
          :key="i"
          class="controls__button"
          :class="{ controls__button_active: activeSpeed === speed }"
          @click="changeMap(speed)"
        >
          {{ speed }}
        </li>
      </ul>
      <div class="controls__border-image" />
      <div
        v-if="popover"
        class="controls__explanation explanation"
        ref="explanation"
      >
        <div class="explanation__item">
          <div class="explanation__title">4G+</div>
          <div class="explanation__text">
            {{ content[language]['4g+'] }}
          </div>
        </div>
        <div class="explanation__item">
          <div class="explanation__title">4G</div>
          <div class="explanation__text">
            {{ content[language]['4g'] }}
          </div>
        </div>
        <div class="explanation__item">
          <div class="explanation__title">3G</div>
          <div class="explanation__text">
            {{ content[language]['3g'] }}
          </div>
        </div>
        <div class="explanation__item">
          <div class="explanation__title">2G</div>
          <div class="explanation__text">
            {{ content[language]['2g'] }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Coverage',
  data() {
    return {
      currentMapPlace: [],
      currentZoom: null,
      speeds: ['2G', '3G', '4G', '4G+'],
      activeSpeed: '4G+',
      zoomLevel: 10,
      popover: false,
      map: null,
      suggest: null,
      region: 0,
      regions: {},
      lat: 47.973163,
      lng: 66.946941,
      place: null,
      wmsCollection: null,
      language: 'ru',
      content: {
        ru: {
          label: 'Город, адрес или регион',
          placeholder: 'Введи данные',
          '4g+':
            'Смотреть видео в 4К, совершать видео-звонки, слушать музыку, играть в игры и скачивать тяжелые файлы, благодаря одновременному использованию нескольких частот. Можно сказать, полноценная замена домашнего интернета.',
          '4g':
            'Смотреть видео в 4К, совершать видео-звонки, слушать музыку, играть в игры и скачивать тяжелые файлы с четвертым поколением связи.',
          '3g':
            'С этой сетью можно слушать музыку, общаться и смотреть ленту в соцсетях, переписываться в мессенджерах и пользоваться поисковыми ресурсами.',
          '2g': 'Сотовая связь 2G позволяет пользоваться поисковыми ресурсами.'
        },
        en: {
          label: 'City, address or region',
          placeholder: 'Enter data',
          '4g+':
            'Watch video in 4K, make video calls, listen to music streaming, play online games and download heavy files via the simultaneous use of several frequencies. It can be almost used instead of home internet.',
          '4g':
            'Watch video in 4K, make video calls, listen to music streaming, play online games and download heavy files with the fourth generation of communication.',
          '3g':
            'With this network you can listen to music, chat and watch a feed in social networks, chat in messengers and use search resources.',
          '2g': '2G cellular connectivity allows you to use search resources.'
        },
        kk: {
          label: 'Қала, мекен-жай немесе аймақ',
          placeholder: 'Деректерді енгізіңіз',
          '4g+':
            'Бірнеше жиілікті қолдану арқылы, 4К бейнесін қарауға, бейне-қоңырауларды жасауға, музыканы тыңдауға, ойын ойнап, ауыр файлдарды жүктеуге болады. Үйдегі интернет сияқты деп айтуға болады.',
          '4g':
            'Төртінші буын байланысымен 4К бейнесін қарауға, бейне-қоңырауларды жасауға, музыка тыңдауға, ойын ойнап, ауыр файлдарды жүктеуге болады.',
          '3g':
            'Осы желімен музыканы тыңдауға, әлеуметтік желілердің легін қарап, араласуға, мессенджерлерде хабарласуға және іздеу ресурстарын пайдалануға болады.',
          '2g':
            '2G ұялы байланысы іздеу ресурстарын пайдалануға мүмкіндік береді.'
        }
      }
    }
  },
  mounted() {
    if (this.$route.query.zoomLevel && Number(this.$route.query.zoomLevel) > 0) {
      this.zoomLevel = this.$route.query.zoomLevel
    }

    // detect language from query param
    switch (this.$route.query.lang) {
      case 'ru':
        this.language = 'ru'
        break
      case 'en':
        this.language = 'en'
        break
      case 'kk':
        this.language = 'kk'
        break
      default:
        this.language = 'ru'
        break
    }

    const ymapPromise = new Promise((resolve, reject) => {
      const yscript = document.createElement('script')
      yscript.setAttribute(
        'src',
        'https://api-maps.yandex.ru/2.1/?lang=ru_RU&apikey=b171d170-0b63-45a0-b115-f366a371cb1b&suggest_apikey=a2c7090c-8c1a-4c2b-8ac5-e2c287b1c159'
      )
      document.head.appendChild(yscript)

      yscript.onload = () => {
        const wmsscript = document.createElement('script')
        wmsscript.setAttribute('src', '/js/wms.js')
        document.head.appendChild(wmsscript)
        resolve(true)
      }
      yscript.onerror = () => {
        reject(false)
      }
    })
    ymapPromise.then(val => {
      if (val) {
        const init = () => {
          // eslint-disable-next-line no-undef
          this.map = new ymaps.Map(
            'map',
            {
              controls: [],
              center: [this.lat, this.lng],
              zoom: this.zoomLevel
            },
            {
              suppressMapOpenBlock: true
            }
          )
          /*
           * get current user geolocation
           * */
          // eslint-disable-next-line no-undef
          const geolocation = ymaps.geolocation
          geolocation
            .get({
              provider: 'auto',
              mapStateAutoApply: true
            })
            .then(result => {
              result.geoObjects.options.set('preset', 'islands#redCircleIcon')
              result.geoObjects.get(0).properties.set({
                balloonContentBody: 'Мое местоположение'
              })
              this.map.geoObjects.add(result.geoObjects)
            })
          // eslint-disable-next-line no-undef
          const geo = new ymaps.control.GeolocationControl({
            options: {
              position: {
                bottom: 40,
                right: 20
              }
            }
          })
          this.map.controls.add(geo)

          this.map.events.add('actionend', function () {
            this.currentMapPlace = this.map.getCenter()
            this.currentZoom = this.map.getZoom()
          }.bind(this));

          // dropdown
          // eslint-disable-next-line no-undef
          this.suggest = new ymaps.SuggestView('search', {
            boundedBy: [
              [40.429654813411126, 48.305664062499986],
              [55.42939357021221, 86.88964843749997]
            ]
            // layout: suggestLayout
            // strictBounds: true
            // offset: [0, 12]
          })
          this.suggest.events.add('select', e => {
            // eslint-disable-next-line no-undef
            let geocoder = ymaps.geocode(e.get('item').value, {
              results: 1
            })
            geocoder.then(res => {
              this.map.geoObjects.removeAll()
              this.map.geoObjects.add(res.geoObjects)
              this.map.setCenter(
                res.geoObjects.get(0).geometry.getCoordinates(),
                17
              )
              this.downControls()
            })
          })
          // trigger wms layers
          this.triggerWms(this)
        }
        // eslint-disable-next-line no-undef
        ymaps.ready(init)
      }
    })
  },
  watch: {
    async popover(val) {
      try {
        if (val) {
          // 195 - height of all elements before explanation block
          setTimeout(() => {
            const controlsHeight = Math.round(
              this.$refs.controls.getBoundingClientRect().height
              )
            document.documentElement.style.setProperty(
              '--explanation',
              `${controlsHeight - 195}px`
              )
          }, 500)
        } else {
          document.documentElement.style.removeProperty('--explanation')
          this.map.setCenter(this.currentMapPlace, this.currentZoom)
        }
      } catch(err) {
        console.log(err)
      }
    }
  },
  methods: {
    triggerWms(ctx) {
      // eslint-disable-next-line no-undef
      ymaps.modules.require(['LayerWMS'], LayerWMS => {
        const url = 'https://coverage.izi.me/geoserver/cite/wms?'
        if (ctx.wmsCollection) {
          ctx.map.layers.remove(ctx.wmsCollection.get('2G'))
          ctx.map.layers.remove(ctx.wmsCollection.get('3G'))
          ctx.map.layers.remove(ctx.wmsCollection.get('4G'))
          ctx.map.layers.remove(ctx.wmsCollection.get('4G+'))

          ctx.map.layers.add(ctx.wmsCollection.get(ctx.activeSpeed))
        } else {
          const twoG = new LayerWMS(url, {
            CQL_FILTER: `coverage_type='2G'`
          })
          const threeG = new LayerWMS(url, {
            CQL_FILTER: `coverage_type='3G'`
          })
          const fourG = new LayerWMS(url, {
            CQL_FILTER: `coverage_type='4G'`
          })
          const fourGplus = new LayerWMS(url, {
            CQL_FILTER: `coverage_type='4G+'`
          })
          // eslint-disable-next-line no-undef
          ctx.wmsCollection = ymaps.layer.storage
          ctx.wmsCollection.add('2G', twoG)
          ctx.wmsCollection.add('3G', threeG)
          ctx.wmsCollection.add('4G', fourG)
          ctx.wmsCollection.add('4G+', fourGplus)

          // init layer 3G
          ctx.map.layers.add(ctx.wmsCollection.get(ctx.activeSpeed))
        }
      })
    },
    upControls() {
      this.$refs.controls.classList.add('controls_full')
      this.popover = true
    },
    downControls() {
      this.$refs.controls.classList.remove('controls_full')
      this.popover = false
    },
    changeMap(speed) {
      this.activeSpeed = speed
      this.triggerWms(this)
    }
  }
}
</script>

<style>
 .ymaps-2-1-79-ground-pane  ymaps:last-child {
    opacity: .67;
 }
 .ymaps-2-1-79-ground-pane  ymaps:first-child {
    opacity: 1;
  }
</style>

<style lang="scss" scoped>
.map {
  width: 100%;
  height: 100vh;
  position: relative;
  min-width: 100vw;
  overflow: hidden;
  z-index: 1000;

  .controls {
    transition: height 300ms ease-in-out;
    box-shadow: 0 8px 24px 0 rgba(40, 44, 54, 0.22),
      0 1px 1px 0 rgba(35, 45, 55, 0.23);
    border-radius: 12px 12px 0 0;
    background-color: #fff;
    position: absolute;
    bottom: 0;
    padding: 6px 14px 25px 14px;
    width: 100%;
    height: 186px;

    &_full {
      height: 80vh;
      overflow: hidden;
    }

    &__swipe {
      width: 36px;
      height: 4px;
      background: #c4c4c4;
      margin: 0 auto 15px auto;
    }

    &__search {
      background-color: #f2f4f7;
      border-radius: 12px;
      margin-bottom: 24px;
    }

    &__label {
      display: block;
      font-size: 0.75rem;
      color: #7e8aa3;
      font-weight: 400;
      margin-bottom: 2px;
      padding: 10px 16px 0 16px;
    }

    &__input {
      outline: none;
      width: 100%;
      border: 0;
      background: none;
      padding: 0 16px 10px 16px;
      overflow: visible;
      margin: 0;
    }

    &__border-image {
      background-image: linear-gradient(
        90deg,
        #b7e9f0 1%,
        #b8cfef 31%,
        #9098e1 67%,
        #6e59d6 100%
      );
      border-radius: 5px;
      height: 8px;
    }

    &__buttons {
      margin-bottom: 4px;
      display: flex;
      overflow: hidden;
    }

    &__button {
      flex-grow: 1;
      text-align: center;
      border-radius: 16px;
      padding: 6px 14px;

      &_active {
        &:nth-child(1) {
          background-color: #b7e9f0;
        }
        &:nth-child(2) {
          background-color: #b8cfef;
        }
        &:nth-child(3) {
          background-color: #9098e1;
        }
        &:nth-child(4) {
          background-color: #6e59d6;
        }
        background-color: #6f5ad6;
        color: white;
      }
    }
  }
}

.explanation {
  $this: &;
  margin-top: 24px;
  overflow-y: auto;
  height: var(--explanation, auto);

  &__item {
    margin-bottom: 15px;

    &:nth-child(1) {
      #{$this}__title {
        &::before {
          background: #6e59d6;
        }
      }
    }

    &:nth-child(2) {
      #{$this}__title {
        &::before {
          background: #9098e1;
        }
      }
    }

    &:nth-child(3) {
      #{$this}__title {
        &::before {
          background: #b8cfef;
        }
      }
    }

    &:nth-child(4) {
      #{$this}__title {
        &::before {
          background: #b7e9f0;
        }
      }
    }
  }

  &__title {
    font-size: 1.125rem;
    font-weight: 500;
    display: flex;
    align-items: center;

    &::before {
      content: '';
      width: 16px;
      height: 16px;
      background: black;
      display: block;
      border-radius: 50%;
      margin-right: 8px;
    }
  }

  &__text {
    font-size: 0.875rem;
  }
}

#map {
  width: 100%;
  height: 100%;
}

.ymaps-2-1-75-search__suggest {
  border: 0;
}
</style>
